import React from 'react';
import { useLocation } from 'react-router-dom';
export default function CertificadoEmitido() {
    const location = useLocation();
    const { certificado } = location.state;

    return (
        <div className='mb-4 mx-4'>
            <div dangerouslySetInnerHTML={{ __html: certificado.conteudo }}></div>
            <div className='mt-5 pt-3 border-top text-center' style={{ fontSize: '0.8rem', color: '#666' }}>
                Autenticidade: {certificado.hash}
            </div>
        </div>
    );
}